<template>
  <span class="print-view">
    <div class="flex justify-center">
      <iframe v-if="file" :src="file" style="width: 100%; height: 100vh; border: none;" />
    </div>
  </span>
</template>

<script>
  import axios from '@/axios'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'ProjectBriefPrintView',
    data() {
      return {
        file: '',
      }
    },
    async mounted() {
      try {
        const response = await axios.get(`/admin/customer/project_brief/${this.$route.params.id}/pdf`, { responseType: 'blob' })
        const file = new Blob([response.data], { type: 'application/pdf' })
        this.file = URL.createObjectURL(file)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    mixins: [ErrorMessages],
  }
</script>
